import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import CareersDetailsForm from "./CareersDetailsForm";
import { apiUrls } from "../../constants/url/ApiUrls";

export default function CareersDetailsContainer() {
  const { title } = useParams();
  const decodeTitle = decodeURIComponent(title);
  const navigate = useNavigate();

  const [errors, setErrors] = useState({});
  const [isSuccess, setIsSuccess] = useState(false);
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    resumeFile: null,
  });

const handleChange = (e) => {
  const { name, type, value, files } = e.target;

  setFormValues((prev) => ({
    ...prev,
    [name]: type === "file" ? files[0] : value,
  }));

  setErrors((prevErrors) => {
    const newErrors = { ...prevErrors };

    // Live validate Name
    if (name === "name") {
      if (!value.trim()) {
        newErrors.name = "Please enter your name.";
      } else if (value.trim().length < 2) {
        newErrors.name = "Name must be at least 2 characters.";
      } else {
        newErrors.name = "";
      }
    }

    // Live validate Email
    if (name === "email") {
      if (!value.trim()) {
        newErrors.email = "Please enter your email.";
      } else if (!validateEmail(value.trim())) {
        newErrors.email = "Please enter a valid email address.";
      } else {
        newErrors.email = "";
      }
    }

    // Clear resumeFile error when user selects file
    if (name === "resumeFile" && files?.[0]) {
      newErrors.resumeFile = "";
    }

    return newErrors;
  });
};


  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!formValues.name.trim()) {
      newErrors.name = "Please enter your name.";
    } else if (formValues.name.trim().length < 2) {
      newErrors.name = "Name must be at least 2 characters.";
    }

    if (!formValues.email.trim()) {
      newErrors.email = "Please enter your email.";
    } else if (!validateEmail(formValues.email.trim())) {
      newErrors.email = "Please enter a valid email address.";
    }

    if (!formValues.resumeFile) {
      newErrors.resumeFile = "Please upload your resume.";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.error("Please fix the form errors.", { duration: 5000 });
      return;
    }

    const formData = new FormData();
    formData.append("name", formValues.name.trim());
    formData.append("email", formValues.email.trim());
    formData.append("position", decodeTitle);
    formData.append("file", formValues.resumeFile);

    try {
      const response = await fetch(apiUrls.resumeUpload, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      console.log(data);

      if (data.message === "File uploaded successfully") {
        setIsSuccess(true);
        setFormValues({
          name: "",
          email: "",
          resumeFile: null,
        });
        setErrors({});
      } else {
        toast.error(data.message || "Something went wrong.", { duration: 5000 });
      }
    } catch (err) {
      console.error("Error uploading resume:", err);
      toast.error("Server error!", { duration: 5000 });
    }
  };

  const handleSuccessOK = () => {
    navigate("/careers");
  };

  if (isSuccess) {
    return (
      <div className="fixed inset-0 flex items-center justify-center z-50 backdrop-blur-sm bg-gray-800/30 px-4">
        <div className="bg-white rounded-md shadow-lg p-10 max-w-lg w-full text-center space-y-4">
          <svg
            className="w-16 h-16 text-green-500 mx-auto mb-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M20 6L9 17l-5-5" />
          </svg>
          <h2 className="text-2xl font-bold text-gray-900">Successfully Uploaded!</h2>
          <p className="text-gray-600 text-sm">
            Your resume has been uploaded successfully.
          </p>
          <div className="flex justify-center gap-4 pt-4">
            <button
              onClick={handleSuccessOK}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md text-sm font-medium transition-all duration-200"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <CareersDetailsForm
      decodeTitle={decodeTitle}
      handleSubmit={handleSubmit}
      handleChange={handleChange}
      formValues={formValues}
      errors={errors}
    />
  );
}
